import { makeAutoObservable } from "mobx";
import { ASAPFulfillmentTime } from "../FulfillmentTime";
import { Availability } from "../Availability";
/**
 * How and where should the order be fulfilled for QrWaiter order.
 */
export class QrWaiterFulfillmentInstructions {
    constructor(params) {
        this.type = "QrWaiter";
        this.isDelivery = false;
        this.streetAddress = null;
        this.apartmentInfo = null;
        /**
         * A way in which the order will be physically fulfilled - DineIn
         */
        this.fulfillmentMethodType = "DineIn";
        /**
         * When the order will be fulfilled - ASAP
         */
        this.fulfillmentTime = ASAPFulfillmentTime.empty();
        this.userNote = params.userNote;
        this.paymentMedium = params.paymentMedium;
        this.paymentPostCode = params.paymentPostCode;
        this.paymentMediumRestored = params.paymentMediumRestored;
        this.dineInLocation = params.dineInLocation;
        makeAutoObservable(this);
    }
    // TODO: Refactor - to another payment class?
    get isPaymentPostCodeRequired() {
        return (this.paymentMedium !== null &&
            this.paymentMedium.type === "channel" &&
            this.paymentMedium.isPostCodeRequired);
    }
    // TODO: Refactor - to another payment class?
    get paymentAvailability() {
        return Availability.boolean({
            PaymentMediumMissing: this.paymentMedium === null,
        });
    }
    get paymentPostCodeAvailability() {
        return this.paymentPostCode !== null
            ? this.paymentPostCode.availability
            : this.isPaymentPostCodeRequired
                ? Availability.unavailable("PostCodeMissing")
                : Availability.available();
    }
    get availability() {
        return Availability.composite([
            this.paymentAvailability,
            this.userNote.availability,
            this.paymentPostCodeAvailability,
        ]);
    }
    get fulfillmentMethod() {
        return this.fulfillmentMethodType;
    }
    // TODO: Refactor - to another payment class?
    get paymentMethodCheckoutData() {
        // TODO: default payment medium / method?
        if (!this.paymentMedium) {
            return "Cash";
        }
        switch (this.paymentMedium.type) {
            case "method":
                return this.paymentMedium.method;
            case "channel":
                return "Online";
        }
    }
    /**
     * @returns data to be sent to the backend
     */
    get checkoutData() {
        return {
            fulfillmentMethod: {
                tag: this.fulfillmentMethodType,
                location: this.dineInLocation,
            },
            paymentMethod: this.paymentMethodCheckoutData,
            requestedFulfillmentTime: this.fulfillmentTime.checkoutData,
            userNote: this.userNote.checkoutData,
        };
    }
    // TODO: Refactor - to another payment class?
    get paymentCheckoutData() {
        var _a, _b;
        if (this.paymentMedium !== null && this.paymentMedium.type === "channel") {
            return {
                applePayToken: null,
                channel: this.paymentMedium.channelId,
                postCode: (_b = (_a = this.paymentPostCode) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : null,
                blikCode: null,
                cardToken: null,
                isIosApp: false,
            };
        }
        return null;
    }
}
